import { Text } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form'
import { useMicroareaImovelSelectFieldQuery } from 'graphql/hooks.generated'
import { MicroareaImovelSelectFieldQuery, TipoEnderecoEnum } from 'graphql/types.generated'

type MicroareaImovelSelectModel = MicroareaImovelSelectFieldQuery['microareasImoveis'][0]

type MicroareaImovelSelectFieldProps = CustomSelectFieldProps<string> & {
  cnes: string
  ine: string
  tipoEndereco: TipoEnderecoEnum
}

const SEM_EQUIPE_ITEM = {
  abreviatura: 'FA',
  extenso: 'Fora de Área',
}

const itemToString = (item: MicroareaImovelSelectModel) =>
  item === SEM_EQUIPE_ITEM.abreviatura ? SEM_EQUIPE_ITEM.extenso : item

const renderItem = (item: MicroareaImovelSelectModel) =>
  item === SEM_EQUIPE_ITEM.abreviatura ? renderItemForaDeArea() : renderItemMicroarea(item)

const renderItemForaDeArea = () => <Text fontWeight='bold'>{SEM_EQUIPE_ITEM.extenso}</Text>

const renderItemMicroarea = (item: MicroareaImovelSelectModel) => <Text fontWeight='bold'>{item}</Text>

export function MicroareaImovelSelectField(props: Readonly<MicroareaImovelSelectFieldProps>) {
  const { cnes, ine, tipoEndereco, ...rest } = props

  const { data } = useMicroareaImovelSelectFieldQuery({
    variables: { input: { cnes, ine, tipoEndereco, stAtivo: true } },
    skip: !cnes || !ine,
  })

  return (
    <SelectField<string> itemToString={itemToString} renderItem={renderItem} items={data.microareasImoveis} {...rest} />
  )
}
